import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["icon"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { INPUT_ICON_POSITIONS } from "../constants";
import { getRem, transitionAnimation } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var inputIconSize = getRem('24px');
var inlineInputIconSize = getRem('14px');
var StyledInputIcon = styled(function (_ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/cloneElement(icon, props);
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasError', 'isDisabled', 'isFocused', 'isInline', 'isReadOnly'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  fill: ", ";\n  flex-shrink: 0;\n  height: ", ";\n  padding-right: ", ";\n  width: ", ";\n  ", "\n  ", "\n    ", "\n"])), transitionAnimation('fill'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.gray['600'].value;
}, inputIconSize, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.small.value;
}, inputIconSize, function (_ref4) {
  var isDisabled = _ref4.isDisabled,
      isFocused = _ref4.isFocused,
      isReadOnly = _ref4.isReadOnly,
      theme = _ref4.theme;
  return isFocused && !isDisabled && !isReadOnly && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      fill: ", ";\n    "])), theme.color.primary['500'].value);
}, function (_ref5) {
  var hasError = _ref5.hasError,
      isDisabled = _ref5.isDisabled,
      theme = _ref5.theme;
  return hasError && !isDisabled && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      fill: ", ";\n    "])), theme.color.system.negative[500].value);
}, function (_ref6) {
  var hasError = _ref6.hasError,
      isInline = _ref6.isInline;
  return hasError && isInline && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), inlineInputIconSize, inlineInputIconSize);
});

var InputIcon = function InputIcon(props) {
  return /*#__PURE__*/_jsx(StyledInputIcon, _objectSpread({}, props));
};

InputIcon.displayName = "InputIcon";
InputIcon.propTypes = {
  /** If true, adjusts label styling */
  hasError: PropTypes.bool,

  /** Icon to be displayed within input field */
  icon: PropTypes.node.isRequired,

  /** If true, input icon is inside inline input */
  isInline: PropTypes.bool,

  /** Sets the position of icon */
  position: PropTypes.oneOf(Object.values(INPUT_ICON_POSITIONS))
};
InputIcon.defaultProps = {
  hasError: false,
  isInline: false,
  position: INPUT_ICON_POSITIONS.TRAILING
};
export { InputIcon };